module.exports = __webpack_public_path__ + "img/banner3.c62ba233.jpg";